import { LevelProgressInfo } from '../bottomSheets';
import {
  BottomSheetComponent,
  registerBottomSheets,
} from '@bonanza-social/navigation';

const bottomSheets = {
  levelProgressInfo: LevelProgressInfo,
};

registerBottomSheets('levels', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    levels: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
